import controller from './dashboard.controller';
import template from './dashboard.view.html';

let DashboardComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default DashboardComponent;



/** WEBPACK FOOTER **
 ** ./www/components/pay-zone/dashboard/dashboard.component.js
 **/